import occurrencesCorrespondenceTable from '../occurencesCorrespondenceTable';

export const EXPERIMENTAL_DESIGN_SET_ACTIVE_MODAL = 'EXPERIMENTAL_DESIGN_SET_ACTIVE_MODAL';
export const EXPERIMENTAL_DESIGN_CLOSE_ALL_MODALS = 'EXPERIMENTAL_DESIGN_CLOSE_ALL_MODALS';

/**
 * Sets an modal active.
 * @param modalType
 * @param modalAction
 * @param modalValue
 * @returns {{type: string, modalType: *, modalAction: *, modalValue: *}}
 */
export const setActiveModal = (modalType, modalAction, modalValue) => {
  return {
    type: EXPERIMENTAL_DESIGN_SET_ACTIVE_MODAL,
    modalType,
    modalAction,
    modalValue
  };
};

/**
 * Closes all modals, reverts to closed state.
 * @returns {{type: string}}
 */
export const closeAllModals = () => {
  return {
    type: EXPERIMENTAL_DESIGN_CLOSE_ALL_MODALS
  };
};

/**
 * Opens an occurrence creation modal
 * @param type
 */
export const openOccurrencesCreateModal = type => {
  return dispatch => {
    dispatch(setActiveModal(type, 'add', true));
  };
};

/**
 * Opens an occurrence creation modal
 * @param type
 */
export const openOccurrencesListModal = type => {
  return dispatch => {
    dispatch(setActiveModal(type, 'list', true));
  };
};

/**
 * Opens an occurrence editing modal
 * @param type
 * @param occurrenceToEdit
 */
export const openOccurrenceEditModal = (occurrenceToEdit, type) => {
  return dispatch => {
    dispatch(setActiveModal(occurrencesCorrespondenceTable[type], 'edit', occurrenceToEdit));
  };
};

/**
 * Opens the confirmation state to delete a condition
 * @param conditionId
 */
export const openDeleteConditionModal = conditionId => {
  return dispatch => {
    dispatch(setActiveModal('condition', 'delete', conditionId));
  };
};

/**
 * Opens the modal for a occurrence stack
 * @param conditionIndex
 * @param occurrenceRow
 * @param occurrenceIndex
 */
export const openConditionOccurrenceStack = (conditionIndex, occurrenceRow, occurrenceIndex) => {
  return dispatch => {
    dispatch(
      setActiveModal('condition', 'stack', { conditionIndex, occurrenceRow, occurrenceIndex })
    );
  };
};

/**
 * Opens a delete occurrence modal for a given occurrence source and ID
 * @param occurrenceId
 * @param occurrenceSource
 */
export const openDeleteGlobalOccurrenceModal = (
  occurrenceId,
  occurrenceSource,
  occurrenceName,
  versionId
) => {
  return dispatch => {
    dispatch(
      setActiveModal('globals', 'delete', {
        id: occurrenceId,
        source: occurrenceSource,
        name: occurrenceName,
        versionId
      })
    );
  };
};



// WEBPACK FOOTER //
// ./src/scenes/projects/scenes/singleProject/data/experimentalDesign/modalActions.js